/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  event_id: string;
}
export interface DashboardGuestInviteCodeRes {
  code: number;
  msg: string;
  data: Data;
}
export interface Data {
  /**
   * 邀请码
   */
  invite_code: string;
}

const DashboardGuestInviteCode = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<DashboardGuestInviteCodeRes>(
    '/wemeet-tapi',
    '/v2/activities/dashboard/guest/invite-code',
    data,
    ctx,
  );

  return res;
};

export default DashboardGuestInviteCode;
